import { apiClient } from './apiClient';

export class InsuranceService {
    constructor() {
        this.baseUrl = '/insurances';
    }

    async fetchInsurances(params = {}) {
        try {
            const queryParams = new URLSearchParams();

            if (params.page) queryParams.append('page', params.page.toString());
            if (params.limit) queryParams.append('limit', params.limit.toString());
            if (params.firstName) queryParams.append('firstName', params.firstName);
            if (params.lastName) queryParams.append('lastName', params.lastName);
            // Entity filter support for UnifiedClaimsFilter
            if (params.name) queryParams.append('name', params.name);
            if (params.contact) queryParams.append('contact', params.contact);
            const sortBy = params.sortBy || 'name';
            const sortOrder = params.sortOrder || 'asc';
            queryParams.append('sortBy', sortBy);
            queryParams.append('sortOrder', sortOrder);

            const response = await apiClient.get(this.baseUrl, { params: queryParams });
            return response;
        } catch (error) {
            console.error('Error fetching insurances:', error);
            throw error;
        }
    }


    async getInsuranceById(id) {
        try {
            const response = await apiClient.get(`${this.baseUrl}/${id}`);
            return response;
        } catch (error) {
            console.error('Error fetching insurance:', error);
            throw error;
        }
    }

    async createInsurance(insuranceData) {
        try {
            const response = await apiClient.post(this.baseUrl, insuranceData);
            return response;
        } catch (error) {
            console.error('Error creating insurance:', error);
            throw error;
        }
    }

    async updateInsurance(id, insuranceData) {
        try {
            const response = await apiClient.patch(`${this.baseUrl}/${id}`, insuranceData);
            return response;
        } catch (error) {
            console.error('Error updating insurance:', error);
            throw error;
        }
    }

    async deleteInsurance(id) {
        try {
            const response = await apiClient.delete(`${this.baseUrl}/${id}`);
            return response;
        } catch (error) {
            console.error('Error deleting insurance:', error);
            throw error;
        }
    }

    async getAdjustorsByInsuranceId(insuranceId) {
        try {
            const response = await apiClient.get(`${this.baseUrl}/${insuranceId}/adjustors`);
            return response;
        } catch (error) {
            console.error('Error fetching adjustors:', error);
            throw error;
        }
    }

    async mergeInsurances(payload) {
        try {
            const response = await apiClient.post(`${this.baseUrl}/merge`, payload);
            return response;
        } catch (error) {
            console.error('Error merging insurances:', error);
            throw error;
        }
    }

    async validateMerge(sourceId) {
        try {
            const response = await apiClient.get(`${this.baseUrl}/merge-validate?sourceId=${sourceId}`);
            return response;
        } catch (error) {
            console.error('Error validating insurance merge:', error);
            throw error;
        }
    }
}

export const insuranceService = new InsuranceService();
